var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo } from 'react';
import { CreateGiveawayModal } from 'root/src/client/v2/giveaways/features/CreateGiveawayModal/CreateGiveawayModal';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
export const CreateGiveawayModalLegacyWrapper = memo(() => {
    const { onSuccess } = useCreateGiveawayModalLegacy();
    return (<CreateGiveawayModal onSuccess={onSuccess}/>);
});
const useCreateGiveawayModalLegacy = () => {
    const creatorDataApi = useCreatorDataApi();
    const onSuccess = () => __awaiter(void 0, void 0, void 0, function* () {
        yield creatorDataApi.fetchScheduler();
        yield creatorDataApi.fetchGiveaways();
    });
    return { onSuccess };
};
